'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFloppyDiskPen, iconFloppyDiskPenTag } from '@ni/nimble-components/dist/esm/icons/floppy-disk-pen';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFloppyDiskPen };
export { iconFloppyDiskPenTag };
export const NimbleIconFloppyDiskPen = wrap(IconFloppyDiskPen);